import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { getConsultationReport } from "~/providers/api";
import { PatientConsultationReport } from "~/providers/utils/types/consultation";

export const useGetConsultationReport = (
  consultationId?: string,
  options?: Partial<UseQueryOptions<PatientConsultationReport | null, Error>>,
) =>
  useQuery({
    queryFn: () => getConsultationReport(consultationId),
    queryKey: ["getConsultationReport", consultationId],
    ...options,
  });
